import { useState } from 'react'

export const useShow = () => {
  const [show, setShow] = useState(false)
  const doHide = () => setShow(false)
  const doShow = () => setShow(true)

  return { show, doHide, doShow }
}
